import {
  ADD_MY_TASK,
  DELETE_MY_TASK,
  SET_ALL_MY_TASKS,
  UPDATE_MY_TASK,
  ADD_COMMENT_TO_MY_TASK,
  UPDATE_COMMENT_TO_MY_TASK,
  DELETE_COMMENT_FROM_MY_TASK,
  ADD_COMMENT_REPLY_TO_MY_TASK,
} from "../types";
import { setExpiry } from "../../common";

const initialState = {
  actionPlans: [],
  implementations: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ALL_MY_TASKS: {
      setExpiry("sustainchange_my_tasks_expiry");
      return {
        ...state,
        actionPlans: payload.actionPlans,
        implementations: payload.implementations,
      };
    }

    case ADD_MY_TASK: {
      if (payload.taskType === "ActionPlan") {
        return {
          ...state,
          actionPlans: [
            {
              board_id: payload?.task?.board_id,
              board_name: payload?.task?.board_name,
              associated_users: payload?.task?.responsible_persons,
              task: payload.task,
            },
            ...state.actionPlans,
          ],
        };
      } else if (payload.taskType === "Implementation") {
        return {
          ...state,
          implementations: [
            {
              board_id: payload?.task?.board_id,
              board_name: payload?.task?.board_name,
              associated_users: payload?.task?.responsible_persons,
              task: payload.task,
            },
            ...state.implementations,
          ],
        };
      }
      return state;
    }

    case UPDATE_MY_TASK: {
      const { taskType, task } = payload;
      // console.log("Payload", payload);
      if (taskType === "ActionPlan") {
        const newActionPlans = state.actionPlans.map((plan) => {
          if (plan?.task?.id === task?.id) {
            return {
              ...plan,
              task: {
                ...plan.task,
                ...task,
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          actionPlans: newActionPlans,
        };
      } else if (taskType === "Implementation") {
        const newImplementations = state.implementations.map((imp) => {
          if (imp?.task?.id === task?.id) {
            return {
              ...imp,
              task: {
                ...imp.task,
                ...task,
              },
            };
          }
          return imp;
        });
        return {
          ...state,
          implementations: newImplementations,
        };
      }
      return state;
    }

    case DELETE_MY_TASK: {
      const { taskType, taskId } = payload;
      if (taskType === "ActionPlan") {
        const newActionPlans = state.actionPlans.filter(
          (plan) => plan?.task?.id !== taskId
        );
        return {
          ...state,
          actionPlans: newActionPlans,
        };
      } else if (taskType === "Implementation") {
        const newImplementations = state.implementations.filter(
          (imp) => imp?.task?.id !== taskId
        );
        return {
          ...state,
          implementations: newImplementations,
        };
      }
      return state;
    }

    case ADD_COMMENT_TO_MY_TASK: {
      const { taskType, taskId, comment } = payload;
      if (taskType === "ActionPlan") {
        const newActionPlans = state.actionPlans.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: [comment, ...plan.task.comments],
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          actionPlans: newActionPlans,
        };
      } else if (taskType === "Implementation") {
        const newImplementations = state.implementations.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: [...plan.task.comments, comment],
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          implementations: newImplementations,
        };
      }
      return state;
    }

    case UPDATE_COMMENT_TO_MY_TASK: {
      const { taskType, taskId, comment } = payload;
      if (taskType === "ActionPlan") {
        const newActionPlans = state.actionPlans.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: plan.task.comments.map((cm) => {
                  if (comment?.comment_id === cm?.comment_id) {
                    return comment;
                  }
                  return cm;
                }),
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          actionPlans: newActionPlans,
        };
      } else if (taskType === "Implementation") {
        const newImplementations = state.implementations.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: plan.task.comments.map((cm) => {
                  if (comment?.comment_id === cm?.comment_id) {
                    return comment;
                  }
                  return cm;
                }),
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          implementations: newImplementations,
        };
      }
      return state;
    }
    case DELETE_COMMENT_FROM_MY_TASK: {
      const { taskType, taskId, commentId } = payload;
      if (taskType === "ActionPlan") {
        const newActionPlans = state.actionPlans.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: plan.task.comments.filter(
                  (cm) => cm?.comment_id !== commentId
                ),
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          actionPlans: newActionPlans,
        };
      } else if (taskType === "Implementation") {
        const newImplementations = state.implementations.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: plan.task.comments.filter(
                  (cm) => cm?.comment_id !== commentId
                ),
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          implementations: newImplementations,
        };
      }
      return state;
    }
    case ADD_COMMENT_REPLY_TO_MY_TASK: {
      const { taskType, taskId, commentId, reply } = payload;
      if (taskType === "ActionPlan") {
        const newActionPlans = state.actionPlans.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: plan.task.comments.map((cm) => {
                  if (cm?.comment_id === commentId) {
                    return { ...cm, children: [...cm.children, reply] };
                  }
                  return cm;
                }),
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          actionPlans: newActionPlans,
        };
      } else if (taskType === "Implementation") {
        const newImplementations = state.implementations.map((plan) => {
          if (plan?.task?.id === taskId) {
            return {
              ...plan,
              task: {
                ...plan.task,
                comments: plan.task.comments.map((cm) => {
                  if (cm?.comment_id === commentId) {
                    return [reply, ...cm];
                  }
                  return cm;
                }),
              },
            };
          }
          return plan;
        });
        return {
          ...state,
          implementations: newImplementations,
        };
      }
      return state;
    }
    default: {
      return state;
    }
  }
}
